<template>
  <div>
    <v-card>
      <v-toolbar color="primary" dark>
        <v-toolbar-title aling="center">Maestro de Competencias</v-toolbar-title>
      </v-toolbar>
      <v-card flat>
        <v-btn absolute dark fab top right color="success" @click="dialog = true">
          <v-icon>mdi-plus</v-icon>
        </v-btn>
        <v-card-text>
          <v-text-field v-model="search" append-icon="mdi-magnify" label="Buscar" single-line hide-details></v-text-field>
          <v-data-table :headers="headers" :items="datos" :items-per-page="5" class="elevation-1" :search="search" >
            <template v-slot:item.actions="{ item }">
              <v-icon small class="mr-2" @click="editItem(item)">mdi-pencil</v-icon>
              <v-icon small @click="deleteItem(item)">mdi-delete</v-icon>
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-btn dark color="blue" @click="cargaMasiva">Carga Masiva</v-btn>
        </v-card-actions>
      </v-card>
    </v-card>

    <v-dialog v-model="dialog" max-width="700px">
      <v-card>
        <v-card-title>
          <span class="headline">{{ formTitle }}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row align="center"> 
              
              <v-col cols="12">
                <v-text-field v-model="editedItem.nombre" label="Ingrese un nombre especifico*" required outlined maxlength="40"></v-text-field>
              </v-col>

              <v-col cols="12">
                  <v-textarea v-model="editedItem.descripcion" outlined label="Ingrese la Descripcion*" rows="2"></v-textarea>
              </v-col>

              <v-col cols="12">
                  <v-textarea v-model="editedItem.casoexito" outlined label="Criterio de Exito" rows="2"></v-textarea>
              </v-col>

              <v-col cols="12">
                  <v-textarea v-model="editedItem.categoria" outlined label="Categoria" rows="2"></v-textarea>
              </v-col>  
              
              <v-col cols="12">
                  <v-textarea v-model="editedItem.resultados" outlined label="Resultados" rows="2"></v-textarea>
              </v-col>

                <v-col cols="4">
                    <v-text-field type="number"  min="1" max="100" prefix="%" v-model="editedItem.peso" label="Peso" required outlined value="0"></v-text-field>
                </v-col>

            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="close">Cancelar</v-btn>
          <v-btn color="blue darken-1" text @click="presave">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


  </div>
</template>
<script>
import axios from "axios";
import api from "../conf/ruta-base";
import store from "../store";
import router from '../router';
export default {
    name: 'Competencias',
    //Creamos las variables que se van a utilizar
    data() {
        return {
            apiPath: "comdic", search: "", dialog: false,
            headers: [
            { text: "Competencia", align: "start", sortable: true, value: "nombre" },
            { text: "Descripción", sortable: true, value: "descripcion" },
            { text: "Acciones", value: "actions", sortable: false }
            ],
            datos: [], selec: '', editedIndex: -1, editedItem: {},
            defaultItem: {
                id: '', nombre: '', descripcion: '', peso: '', casoexito: '', resultados: '',
            }
        }
    },
    created() {
        this.editedItem = Object.assign({}, this.defaultItem);
    },
    mounted() {
    //Consultamos las competencias existentes
    axios
      .get(api.api + this.apiPath)
      .then(r => {
        for (let i = 0; i < r.data.length; i++) {
          this.datos.push(r.data[i])
        }
      })
      .catch(error => {
        console.log(error);
      });
    },
    methods: {
      //Asignamos al objeto temporal de edicion los elementos
        editItem(item) {
            this.editedIndex = this.datos.indexOf(item)
            this.editedItem = Object.assign({}, item);
            this.dialog = true;
        },
      //Validamos los campos
        presave(){
          let bandera = true
          let err = ''
            if(bandera && this.editedItem.nombre.length == 0){
              bandera = false
              err = 'Ingrese el nombre.'
            }

            if(bandera && this.editedItem.descripcion.length == 0){
              bandera = false
              err = 'Debe ingresar la descripción'
            }
      
            if(bandera && (this.editedItem.casoexito.length == 0 || this.editedItem.resultados.length == 0)){
              bandera = false
              err = 'Faltan datos relevantes'
            }

            if(bandera && this.editedItem.peso.length == 0){
              bandera = false
              err = 'Verifique el peso o valor'
            }

          if(bandera){
            this.save()
          }else{
            swal('',err,'error');
          }
          
        },

      //Aqui salvamos o editamos
        save() {
            if(this.editedIndex > -1) {
                Object.assign(this.datos[this.editedIndex], this.editedItem)
                axios
                .put(api.api + this.apiPath, this.editedItem)
                .then(res => {
                    this.toast(res.data.c, res.data.mensaje)
                })
                .catch(error => {
                    console.log(error);
                });
            } else {
                axios
                .post(api.api + this.apiPath, this.editedItem)
                .then(res => {
                    this.datos.push(res.data);
                    this.toast(res.data.c, res.data.mensaje);
                })
                .catch(error => {
                    console.log(error);
                });
            }
            this.close()
        },
      //Metodo para borrar
        deleteItem (item) {
          const index = this.datos.indexOf(item)
          swal({text: "¿Seguro que desea eliminar?",icon: "warning", buttons: ["Cancelar", "Ok"],})
          .then(ok => {             
            if(ok){
            axios.delete(api.api + this.apiPath, {data: item})
            .then(res => {
                if(res.data.c=='success'){
                this.datos.splice(index, 1)
                }
                this.toast(res.data.c, res.data.mensaje);
            })
            .catch(error => {
                console.log(error);
            });
            }
          })
        },
      //Cerramos el dialogo y liberamos las variables  
        close() {
            this.dialog = false
            this.editedItem = Object.assign({}, this.defaultItem)
            this.editedIndex = -1
        },
      //enviamos a la pantalla de carga masiva
        cargaMasiva(){
          router.push('/competenciasmasivo')
        },
      //Muestra alerta
        toast(color, text) {
            var toast = { color, text }
            store.commit("TOAST", toast)
        }
    },
    computed: {
      //Mostramos el titulo del dialogo segun se presente
        formTitle() {
            return this.editedIndex === -1 ? 'Competencia' : "Modificar Competencia";
        }
  },
}
</script>